(function(){
  'use strict';
  document.querySelectorAll('[data-native-video]').forEach(function(button){
    button.addEventListener('click',function(){
      var frame=button.parentElement.querySelector('iframe');
      if(!frame)return;
      var url=new URL(frame.src);url.searchParams.set('mute','0');url.searchParams.set('controls','1');url.searchParams.set('start','0');
      frame.src=url.toString();button.hidden=true;
    });
  });
  document.querySelectorAll('[data-native-photo]').forEach(function(button){
    button.addEventListener('click',function(){
      var image=button.querySelector('img');if(!image)return;
      var dialog=document.createElement('dialog');dialog.className='cc-native-dialog';dialog.setAttribute('aria-label',image.alt);
      var close=document.createElement('button');close.type='button';close.textContent='×';close.setAttribute('aria-label','Close photo');
      dialog.appendChild(close);dialog.appendChild(image.cloneNode());document.body.appendChild(dialog);
      close.addEventListener('click',function(){dialog.close()});dialog.addEventListener('click',function(e){if(e.target===dialog)dialog.close()});
      dialog.addEventListener('close',function(){dialog.remove();button.focus()});dialog.showModal();close.focus();
    });
  });
})();
